
import styled from 'styled-components';

const blue = "#7DB9E8";
const grey = "#D1D1D1";

export const Title = styled.div`
  display: flex;
  justify-content: center;
  color: white;
  font-size: 34px;
  font-weight: bold;
  width: 100%;

  img {
    width:80%
  }

`

export const Form = styled.form`
    display: flex;
    flex-direction: column;
    gap: 12px;

    label {
        font-weight: bold;
        margin-bottom: 4px;
    }

    input, textarea {
        padding: 10px;
        border: 1px solid #ccc;
        border-radius: 8px;
        font-size: 14px;
        transition: border 0.3s ease;
    }

    input:focus, textarea:focus {
        border-color: #007a33;
        outline: none;
    }

    button {
        background: ${blue};
        color: white;
        padding: 12px;
        border: none;
        border-radius: 8px;
        cursor: pointer;
        transition: background 0.3s ease;
    }

    button:hover {
        background: ${blue}50;
    }
`;

export const Viikot = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
  gap: 5px;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 8px;
  padding: 10px 20px;
  margin: 10px 0;

  h1,
  p{
    margin: 3px;
  }
`

export const Details = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
  gap: 5px;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 8px;
  padding: 10px 20px;
  margin: 10px 0;

  h1,
  p{
    margin: 3px;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .content {
    display: grid;
    gap: 0px;
  }

   /* Responsive Design */
  @media (max-width: 600px) {
    .header {
      flex-direction: column;
      align-items: flex-start;
      gap: 0px;
    }

    h1 {
      font-size: 18px;
    }

    .date-range {
      font-size: 13px;
    }

    h2 {
      font-size: 20px;
    }
  }

`

export const CalendarContainer = (theme=blue) => { 
  return styled.div`
  margin: 3px;
  position: relative;
  background: linear-gradient(to left, 
    ${theme} 20%, 
    ${grey} 20%,
    ${grey} 40%,
    ${theme} 40%);
  background-size: 30px 100%;
  padding: 20px;
  border-radius: 8px;
  height: 100%;

  .react-calendar{
    background: rgba(265, 265, 265, 0.7);;
    border-radius: 8px;
    padding: 20px;
  }

  .react-calendar__navigation {
    display: flex;
    margin-bottom: 10px;
    .react-calendar__navigation__label {
      font-weight: bold;
    }
    .react-calendar__navigation__arrow {
      flex-grow: 0.111;
    }
  }

  .react-calendar__month-view__weekNumbers{
    flex-basis: calc(5%) !important;
    gap: 5px;
    .react-calendar__tile{
      font-weight: bold;
      padding: 5px
    }

  }

  .react-calendar__month-view__weekdays{
    font-weight: bold;
    .react-calendar__month-view__weekdays__weekday{
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }



  button {
    margin: 3px;
    background-color: white;
    border: 0;
    border-radius: 3px;
    color: black;
    padding: 5px 0;

    &:hover{
      background-color: ${theme}50;
    }
    &:active {
      background-color: ${theme}50;
    }
  }

  .react-calendar__tile--range {
    background-color: ${theme}50;
  }
  .react-calendar__tile--disabled {
    background-color: ${theme};
  }
  .exchangeDate{
    background: linear-gradient(
        135deg,
        ${theme} 47%,
        white 48%,
        white 52%,
        ${theme} 53%
    );
  }
  .startDate{
    background: linear-gradient(
          135deg,
          white 50%,
          ${theme} 51%
      );
  }
  .endDate{
    background: linear-gradient(
          135deg,
          ${theme} 49%,
          white 50%
      );
  }
  .booked{
    background-color: ${theme}
  }


  .react-calendar__month-view__days {
    display: grid !important;
    grid-template-columns: 14.2% 14.2% 14.2% 14.2% 14.2% 14.2% 14.2%; 

    .react-calendar__tile {
      max-width: initial !important;
    }
  }

  /* ~~~ neighboring month & weekend styles ~~~ */
  .react-calendar__month-view__days__day--neighboringMonth {
    opacity: 0.5;
  }
  .react-calendar__month-view__days__day--weekend {
  }

  /* ~~~ other view styles ~~~ */
  .react-calendar__year-view__months {
    display: grid !important;
    grid-template-columns: 20% 20% 20% 20% 20%;

    &.react-calendar__year-view__months {
      grid-template-columns: 33.3% 33.3% 33.3%;
    }

    .react-calendar__tile {
      max-width: initial !important;
    }
  }
`}